<template>
    <lay-row space="10">
        <lay-col md="24">
            <lay-panel style="padding: 10px"> 
                    <lay-table 
                        :page="payInfoPage" 
                        :height="'100%'"
                        :columns="columns" 
                        :loading="loading"
                        :default-toolbar="false"
                        :data-source="payIndataSource" 
                        v-model:selected-keys="selectedKeys"  
                        @change="payInfoChange"
                        @sortChange="sortChange"> 
                        <template v-slot:toolbar>
                          <div style="  display: flex;      align-items: center;">   
                            <div style="margin-right: auto; "> <lay-button type="primary" @click="addPayInfos">添加</lay-button></div>
                            <div style="  text-align: center; ">
                                <h1>支付信息列表</h1>
                            </div>
                        </div> 
                        </template> 
                        <template v-slot:operator="{ row }"> 
                          <lay-button size="xs" @click="payInfoEdit(row)">编辑</lay-button>
                        <lay-button size="xs" @click="payInfoRemove(row)">删除</lay-button>
                        </template>
                        <template #status="{ row }">
                            <lay-switch  :model-value="row.state == 0 ? true : false" @change="payInfoChangeStatus($event , row)"></lay-switch>
                            </template>

                            <template #type="{ row }">
                             <span v-if="row.type==1">支付宝（减免）</span>
                             <span v-else-if="row.type==2">微信（减免）</span>
                             <span v-else-if="row.type==3">支付宝（减免+优惠价）</span>
                             <span v-else-if="row.type==4">微信（减免+优惠价）</span>
                             <span v-else-if="row.type==5">支付宝+微信（优惠价）</span>
                            </template>

                            <template #payType="{ row }">
                             <span v-if="row.payType==0">时长充值</span>
                             <span v-else-if="row.payType==1">金币充值</span>
                              
                            </template>


                            

                    </lay-table> 
            </lay-panel>
 
            <lay-layer v-model="isPayInfo" :shade="false" :area="['450px', '560px']" :btn="payInfoBtn" title="添加/编辑支付信息">
                <div style="padding: 20px;">
                <lay-form :model="payInfo"   >
                  <lay-form-item label="原价格" prop="originalPrice">
                    <lay-input v-model="payInfo.originalPrice"></lay-input>
                    </lay-form-item>
                    <lay-form-item label="现价格" prop="amount">
                    <lay-input v-model="payInfo.amount"></lay-input>
                    </lay-form-item>

                    <lay-form-item label="天数" prop="days" >
                    <lay-input v-model="payInfo.days" ></lay-input>
                    </lay-form-item>   

                    <lay-form-item label="金币" prop="gold" >
                    <lay-input v-model="payInfo.gold" ></lay-input>
                    </lay-form-item>    

                    <lay-form-item label="说明" prop="caption" >
                    <lay-input v-model="payInfo.caption" ></lay-input>
                    </lay-form-item>  
                    <lay-form-item label="类型" prop="type" > 
                        <lay-select v-model="payInfo.type" placeholder="请选择">
                            <lay-select-option :value="1" label="支付宝（减免）"></lay-select-option>
                            <lay-select-option :value="2" label="微信（减免）"></lay-select-option>
                            <lay-select-option :value="3" label="支付宝（减免+优惠价）"></lay-select-option>
                            <lay-select-option :value="4" label="微信（减免+优惠价）"></lay-select-option>
                            <lay-select-option :value="5" label="支付宝+微信（优惠价）"></lay-select-option> 
                        </lay-select>
                 </lay-form-item> 

                 <lay-form-item label="支付类型" prop="payType" > 
                        <lay-select v-model="payInfo.payType" placeholder="请选择">
                            <lay-select-option :value="0" label="时长充值"></lay-select-option>
                            <lay-select-option :value="1" label="金币充值"></lay-select-option>
                           
                        </lay-select>
                 </lay-form-item> 


                 

                 <lay-form-item label="减免多少" prop="reducedPrice" >
                    <lay-input v-model="payInfo.reducedPrice" ></lay-input>
                    </lay-form-item>  

                    <lay-form-item label="优惠价格" prop="specialPrice" >
                    <lay-input v-model="payInfo.specialPrice" ></lay-input>
                    </lay-form-item>  


                </lay-form>
                </div>
            </lay-layer>

        </lay-col>

        <lay-col md="24">
            <lay-panel style="padding: 10px">
                <lay-table 
                        :page="paymentChannelPage" 
                        :height="'100%'"
                        :columns="paymentChannel" 
                        :loading="loading"
                        :default-toolbar="false"
                        :data-source="paymentChannelPdataSource" 
                        v-model:selected-keys="selectedKeys"  
                        @change="paymentChannelChange"
                        @sortChange="sortChange"> 
                        <template v-slot:toolbar> 
                            <div style="  display: flex;      align-items: center;">  
                            <div style="margin-right: auto; "> <lay-button type="primary" @click="addPaymentChannelInfo">添加</lay-button></div>
                            <div style="  text-align: center; ">
                                <h1>支付渠道列表</h1>
                            </div>
                        </div>
                          
                        </template> 
                        <template v-slot:operator="{ row }"> 
                          <lay-button size="xs" @click="paymen(row)">支付</lay-button>
                          <lay-button size="xs" @click="paymentChannelEdit(row)">编辑</lay-button>
                           <lay-button size="xs" @click="paymentChannelRemove(row)">删除</lay-button>
                        </template>
                        <template #status="{ row }">
                            <lay-switch :model-value="row.state == 0 ? true : false"  @change="paymentChannelChangeStatus(row)"></lay-switch>
                            </template> 
                            
                    </lay-table> 
            </lay-panel>

            <lay-layer v-model="isPaymentChannelInfo" :shade="false" :area="['500px', '730px']" :btn="paymentChannelBtn" title="添加支付渠道">
                <div style="padding: 20px;">
                <lay-form :model="paymentChannelInfo"   >
                    <lay-form-item label="api网关" prop="apiUrl">
                    <lay-input v-model="paymentChannelInfo.apiUrl"></lay-input>
                    </lay-form-item>

                    <lay-form-item label="平台名称" prop="platformName" >
                      <lay-input v-model="paymentChannelInfo.platformName"></lay-input> 
                    </lay-form-item> 

                    <lay-form-item label="支付接口" prop="payApi" >
                      <lay-input v-model="paymentChannelInfo.payApi"></lay-input> 
                    </lay-form-item> 

                    <lay-form-item label="调用方法" prop="platform" >
                      <lay-input v-model="paymentChannelInfo.platform"></lay-input> 
                    </lay-form-item> 
 
                    <lay-form-item label="商户id" prop="merchantId" >
                    <lay-input v-model="paymentChannelInfo.merchantId" ></lay-input>
                    </lay-form-item> 

                    <lay-form-item label="支付宝编码" prop="payCode" >
                    <lay-input v-model="paymentChannelInfo.payCode" ></lay-input>
                    </lay-form-item> 

                    <lay-form-item label="微信编码" prop="weChatCode" >
                    <lay-input v-model="paymentChannelInfo.weChatCode" ></lay-input>
                    </lay-form-item> 
                    <lay-form-item label="微信手续费" prop="weChatHandlingFee" > 
                    <lay-input v-model="paymentChannelInfo.weChatHandlingFee" ></lay-input>
                    </lay-form-item> 
                    <lay-form-item label="支付宝手续费" prop="payHandlingFee" >
                    <lay-input v-model="paymentChannelInfo.payHandlingFee" ></lay-input>
                    </lay-form-item> 
                    

                    <lay-form-item label="支付回调地址" prop="callbackUrl" >
                    <lay-input v-model="paymentChannelInfo.callbackUrl" ></lay-input>
                    </lay-form-item> 

                    <lay-form-item label="充值成功地址" prop="successPageUrl" >
                    <lay-input v-model="paymentChannelInfo.successPageUrl" ></lay-input>
                    </lay-form-item> 

                    <lay-form-item label="商户key" prop="merchantKey" >
                    <lay-input v-model="paymentChannelInfo.merchantKey" >></lay-input>
                    </lay-form-item> 
                    
                    
                </lay-form>
                </div>
            </lay-layer>
        </lay-col>
    </lay-row>





    <lay-layer v-model="isaymen" :shade="false" :area="['400px', '300px']" :btn="paymenBtn" title="支付">
                <div style="padding: 20px;">
                <lay-form :model="paymenInfo"   >
                  <lay-form-item label="支付平台" prop="amount">
                  <lay-select v-model="paymenInfo.key" placeholder="请选择">
                  <lay-select-option :value="1" label="微信"></lay-select-option>
                  <lay-select-option :value="0" label="支付宝"></lay-select-option> 
                </lay-select>
              </lay-form-item>

                    <lay-form-item label="支付金额" prop="keyWord">
                    <lay-input v-model="paymenInfo.keyWord"></lay-input>
                    </lay-form-item> 
                </lay-form>
                </div>
            </lay-layer>
</template>

<script  lang="ts" setup>
import { ref, reactive } from 'vue';
import { layer } from '@layui/layui-vue';

import { addPayInfo,allPayInfo,payInfoState,delPayInfo,addPaymentChannel,allPaymentChannel,paymentChannelState,delPaymentChannel,pay } from '../../api'


const loading = ref(false); 
    const selectedKeys:any = ref([]);
    const payIndataSource = ref([])

    const payInfoPage = reactive({ current: 1, limit: 10, total: 0 });

    const columns = ref([  
       { title:"状态", width: "80px", key:"state" ,align:"center",customSlot:'status'}, 
      { title:"原价格", key:"originalPrice" ,align:"center" }, 
      { title:"现价格", key:"amount" ,align:"center" }, 
      { title:"天数/金币", key:"days" ,align:"center" },  
      { title:"金币", key:"gold" ,align:"center" },  
      { title:"说明", key:"caption" ,align:"center" },    
      { title:"类型" , key:"type" ,align:"center",customSlot:'type'}, 
      { title:"支付类型" , key:"payType" ,align:"center",customSlot:'payType'}, 
      { title:"减免" , key:"reducedPrice" ,align:"center"}, 
      { title:"优惠" , key:"specialPrice" ,align:"center"}, 
      { title:"时间", width: "120px", key:"addTime" ,align:"center"},
      { title:"操作", customSlot:"operator", key:"operator", fixed: "right", ignoreExport: true }
    ]);

    const  paymentChannel= ref([ 
       { title:"状态", width: "80px", key:"state" ,align:"center",customSlot:'status'},  
      { title:"平台名称", key:"platformName" ,align:"center" },  
      { title:"支付接口", key:"payApi" ,align:"center" }, 
      { title:"api网关", key:"apiUrl" ,align:"center" }, 
      { title:"商户id", key:"merchantId" ,align:"center" }, 
      { title:"支付宝编码", key:"payCode" ,align:"center" },   
      { title:"微信编码", key:"weChatCode" ,align:"center" },   
      { title:"支付回调地址", key:"callbackUrl" ,align:"center" },   
      { title:"充值成功地址", key:"successPageUrl" ,align:"center" },   
      { title:"商户key", key:"merchantKey" ,align:"center" }, 
    
      { title:"时间", width: "120px", key:"addTime" ,align:"center"},
      { title:"操作",  customSlot:"operator", width: "150px", key:"operator", fixed: "right", ignoreExport: true }
     
    ]);

   const  getAllPayInfo=()=>{

    var data = { "page": payInfoPage.current, "limit": payInfoPage.limit};
    allPayInfo(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
        payIndataSource.value = []; 
      payIndataSource.value = res.data;
      payInfoPage.total = res.count;
    } else {
        payIndataSource.value = [];
        payInfoPage.total = 0;
    }
  })

   }

   getAllPayInfo();  

    const payInfoChange = (page:any) => {
        getAllPayInfo(); 
    }

    const sortChange = (key:any, sort:any) => {
      layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
    }



    const payInfoChangeStatus = (isChecked:any, row:any) => {
         var data={"id":row.id,"key":row.state};
        payInfoState(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {

          layer.msg("操作成功", { time: 1000, icon: 1 })

             getAllPayInfo();  
        }
      })

 
    }

    const payInfoRemove = (row:any) => {
        var data={"id":row.id,"key":row.state};
        delPayInfo(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
            layer.msg("删除成功", { time: 1000, icon: 1 })
             getAllPayInfo();  
        }
      })
    }

  






   const isPayInfo=ref(false) 
     //添加支付信息
  
  const  addPayInfos=()=>{ 
    payInfo.id=0;
    payInfo.state=0;
    payInfo.amount=""; 
    payInfo.originalPrice=""; 
    payInfo.reducedPrice=""; 
    payInfo.specialPrice=""; 
    payInfo.days=""; 
    payInfo.caption=""; 
    payInfo.type=""; 
    payInfo.gold=0; 
    
    isPayInfo.value = !isPayInfo.value; 
  }
 
  const payInfo = reactive({
    id:0,
    amount: "",
    days:"",
    caption:"",
    type:"",
    state:0,
    payType:0,
    originalPrice:"",
    reducedPrice:"",
    specialPrice:"",
    gold:0, 
  })

  const payInfoEdit=(row:any)=>{ 
    payInfo.id=row.id;
    payInfo.state=row.state;
    payInfo.amount=row.amount;
    payInfo.originalPrice=row.originalPrice;
    payInfo.reducedPrice=row.reducedPrice;
    payInfo.specialPrice=row.specialPrice;
    payInfo.days=row.days;
    payInfo.caption=row.caption;
    payInfo.type=row.type; 
    payInfo.gold=row.gold; 
    payInfo.payType=row.payType;  
    isPayInfo.value = !isPayInfo.value; 
  }




const  payInfoBtn= ref([
    {
        text: "确认",
        callback: () => { 
       
            addPayInfo(JSON.stringify(payInfo)).then((res: any) => {
                      if (res != "" && res.code == 0) {
                        getAllPayInfo(); 
                        layer.msg("操作成功", { time: 1000, icon: 1 })
                        isPayInfo.value = !isPayInfo.value; 
                      }
                    })

        }
    },
    {
        text: "取消",
        callback: () => {
            isPayInfo.value = !isPayInfo.value; 
        }
    }
])


//支付渠道
const  isPaymentChannelInfo=ref(false) ;
const  addPaymentChannelInfo=()=>{ 

       paymentChannelInfo.id=0;
     paymentChannelInfo.apiUrl="";
     paymentChannelInfo.platform=0;
     paymentChannelInfo.platformName="";
     paymentChannelInfo.merchantId="";
     paymentChannelInfo.payCode="";
     paymentChannelInfo.weChatCode="";
     paymentChannelInfo.payApi="";
     paymentChannelInfo.callbackUrl="";
     paymentChannelInfo.successPageUrl="";
     paymentChannelInfo.merchantKey="";
     paymentChannelInfo.weChatHandlingFee="";
     paymentChannelInfo.payHandlingFee="";

    isPaymentChannelInfo.value = !isPaymentChannelInfo.value; 
  }


  const paymentChannelInfo = reactive({
    id:0,
    apiUrl: "",
    platform:0,
    platformName:"",
    merchantId:"",
    payCode:"",
    weChatCode:"",
    payApi:"",
    callbackUrl:"",
    successPageUrl:"",
    merchantKey:"", 
    weChatHandlingFee:"", 
     payHandlingFee:"", 
})
  

const  paymentChannelEdit=(row:any)=>{ 
        
     paymentChannelInfo.id=row.id;
     paymentChannelInfo.apiUrl=row.apiUrl;
     paymentChannelInfo.platform=row.platform;
     paymentChannelInfo.platformName=row.platformName;
     paymentChannelInfo.merchantId=row.merchantId;
     paymentChannelInfo.payCode=row.payCode;
     paymentChannelInfo.weChatCode=row.weChatCode;
     paymentChannelInfo.payApi=row.payApi;
     paymentChannelInfo.callbackUrl=row.callbackUrl;
     paymentChannelInfo.successPageUrl=row.successPageUrl;
     paymentChannelInfo.merchantKey=row.merchantKey; 
     paymentChannelInfo.weChatHandlingFee=row.weChatHandlingFee; 
     paymentChannelInfo.payHandlingFee=row.payHandlingFee; 
    isPaymentChannelInfo.value = !isPaymentChannelInfo.value; 
  }



  const  paymentChannelBtn= ref([
    {
        text: "确认",
        callback: () => { 
       
            addPaymentChannel(JSON.stringify(paymentChannelInfo)).then((res: any) => {
                      if (res != "" && res.code == 0) {
                        getAllPaymentChannel();
                        layer.msg("操作成功", { time: 1000, icon: 1 })
                        isPaymentChannelInfo.value = !isPaymentChannelInfo.value; 
                      }
                    })

            
        }
    },
    {
        text: "取消",
        callback: () => {
            isPaymentChannelInfo.value = !isPaymentChannelInfo.value; 
        }
    }
])

//显示信息


const paymentChannelPage = reactive({ current: 1, limit: 10, total: 0 });

 const paymentChannelPdataSource=ref([])


const  getAllPaymentChannel=()=>{

    var data = { "page": paymentChannelPage.current, "limit": paymentChannelPage.limit};
    allPaymentChannel(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
        paymentChannelPdataSource.value = []; 
        paymentChannelPdataSource.value = res.data;
      payInfoPage.total = res.count;
    } else {
        paymentChannelPdataSource.value = [];
        paymentChannelPage.total = 0;
    }
  })
}

getAllPaymentChannel();
const  paymentChannelChange=()=>{

    getAllPaymentChannel();
}


const paymentChannelChangeStatus = ( row:any) => {
         var data={"id":row.id,"key":row.state};
         paymentChannelState(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
          layer.msg("操作成功", { time: 1000, icon: 1 })
            getAllPaymentChannel();
            
        }
      })

 
    }

    const paymentChannelRemove = (row:any) => {
        var data={"id":row.id,"key":row.state};
        delPaymentChannel(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
            layer.msg("删除成功", { time: 1000, icon: 1 })
            getAllPaymentChannel();
        }
      })
    }

    const paymenInfo = reactive({
    id:0,
    keyWord: "", 
    key: "1",
    })

    const isaymen=ref(false) ;

    const paymen = (row:any) => {
      paymenInfo.id=row.id; 
      isaymen.value=!isaymen.value

    }


    

    const  paymenBtn= ref([
    {
        text: "确认",
        callback: () => { 
       
          pay(JSON.stringify(paymenInfo)).then((res: any) => {
                      if (res != "" && res.code == 0) {
                        window.open(res.data); 
                        isaymen.value = !isaymen.value; 
                      }
                    })

        }
    },
    {
        text: "取消",
        callback: () => {
          isaymen.value = !isaymen.value; 
        }
    }
])



</script>
